import { render } from "./NcrmWorkflowMailjetTriggerSettings.vue?vue&type=template&id=ee87d8c2"
import script from "./NcrmWorkflowMailjetTriggerSettings.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowMailjetTriggerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__